module.exports = __webpack_public_path__ + "img/2.b02b01c3.png";